import { CommonModule } from "@angular/common";

import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TabsComponent} from "./tabs.component";
import { TranslateModule } from "@ngx-translate/core";
import { TabBackOfficeComponent } from "./tabs.backoffice";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule
    ],
    declarations: [
        TabsComponent,
        TabBackOfficeComponent,
    ],
    exports: [
        TabsComponent,
        TabBackOfficeComponent,
    ]
})
export class TabsModule { }